<template>
    <div id="project-spinner" v-if="isLoading">
        <base-spinner></base-spinner>  
    </div>
  <router-view v-else></router-view>
</template>

<script setup>
    import BaseSpinner from './components/ui/BaseSpinner.vue'
    import { ref, onMounted } from 'vue'

    const isLoading = ref(false);

    onMounted(() => {
      isLoading.value = true;
      document.fonts.ready.then(() => {
        isLoading.value = false;
      });
    });

</script>

<style>
    html {
      width: 100vw;
    }
    body, #app {
      width: 100%;
      overflow-x: hidden;
      margin: 0;
    }

    #project-spinner {
        position: relative;
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 5;
        background-color: black;
    }

    #project-spinner .spinner {
        background-color: unset;
    }

    .animated-container {
        overflow-x: hidden;
        animation: scaleOut 2s linear forwards alternate;
        transform-origin: top center;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    /* SWIPE CONTENT ANIMATION */
    @keyframes scaleOut {
        0% {
            transform: scale(0);
            opacity: 0;
        }
        50% {
            transform: scale(0.5);
            opacity: 0.5;
        }
        100% {
            transform:  scale(1);
            opacity: 1;
        }
    }
</style>
